// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@page{size:landscape;size:8in 4in;margin:0}", "",{"version":3,"sources":["webpack://./resources/css/receipt.css"],"names":[],"mappings":"AAAA,MACI,cAAe,CACf,YAAa,CACb,QACJ","sourcesContent":["@page {\n    size: landscape;\n    size: 8in 4in;\n    margin: 0mm;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
